import { Icon, type IconProps } from './Icon';

export function Shuffle(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M19 18.9785L21 16.9785L19 14.9785" />
      <path d="M10.182 8.99992L8.602 6.82792C8.224 6.30792 7.619 6.00192 6.976 6.00392L3 6.02092" />
      <path d="M19 8L21 6L19 4" />
      <path d="M13.8179 14L15.3979 16.172C15.7759 16.692 16.3809 16.998 17.0239 16.996L20.9999 16.979" />
      <path d="M21 6.02093L17.024 6.00393C16.381 6.00093 15.776 6.30793 15.398 6.82793L8.602 16.1719C8.224 16.6919 7.619 16.9979 6.976 16.9959L3 16.9789" />
    </Icon>
  );
}
